module.exports = __webpack_public_path__ + "img/logo.11affcb1.svg";